export class CustomerDTO {
    constructor(
        public id: string,
        public firstName: string | null,
        public lastName: string | null,
        public emailAddress: string | null,
        public phoneNumber: string | null,
        public notes: string[],
        public foodDrinkPreferences: string | null,
        public vip: boolean,
        public venueId: string,
        public emailAddressAliases: string[],
        public barred: boolean = false,
        public sendFeedbackRequest: boolean = true,
        public cardDetailsNotRequired: boolean = false,
        public depositAmount: number | null = null,
        public numberOfTimesVisited: number | null = null,
        public numberOfNoShowsAndCancellations: number | null = null,
        public latestReviewScore: number | null = null,
        public dateStatisticsUpdated: string | null = null
    ) { }
}
